export default class ProductCheckAggregateController {
  /* @ngInject */
  constructor(RouterService, ProductService, GeographyService, HttpService, $timeout) {
    this.routerService = RouterService;
    this.productService = ProductService;
    this.geographyService = GeographyService;
    this.httpService = HttpService;
    this.timeout = $timeout;
  }

  $postLink() {
    // se tolgo timeout non sempre regionId è valorizzato
    this.timeout(() => {
      const {id} = this.routerService.state.params;
      const {regionId, size} = this.routerService.location.search();

      this.tableTitles = ['Market', 'Stock'];
      this.productService.getAggregateStocksByMarket(id, {regionId, size})
        .then(aggregateStock => this._getMarketsAndAggregateStock(aggregateStock))
        .then(([markets, aggregateStock]) => this.tableMarkets = this._formatTableMarkets(markets, aggregateStock));
    });
  }

  _getMarketsAndAggregateStock(aggregateStock) {
    const ids = aggregateStock.map(m => m.marketId);
    return this.httpService.all([
      this.geographyService.getMarkets({params: {'filter[ids]': ids.join(',')}}),
      aggregateStock,
    ]);
  }

  _formatTableMarkets(markets, aggregateStock) {
    return aggregateStock.map((stock) => {
      const currentMarket = markets.find(m => m.id === stock.marketId);
      const name = currentMarket.name;
      return [name, stock.quantity];
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/product/product-check/product-check-aggregate/product-check-aggregate.controller.js